import StorageManager from "storage_manager"

export default new StorageManager("_kh_us")
